export const browserCanShare = (): boolean =>
  typeof window !== 'undefined' && typeof window.navigator.share !== 'undefined';
